import { getBase64FromBlob } from '@/Utils';
export const shareBlobOnMobile = async (mobileDevice, isNativeMobileWeb, blob, filename) => {
    if (!isNativeMobileWeb) {
        throw new Error('Share function being used outside mobile webview');
    }
    const base64 = await getBase64FromBlob(blob);
    void mobileDevice.shareBase64AsFile(base64, filename);
};
